import supabase from '../config/supabase';

export function validateApplication(input) {
  const name = String(input.name || '').trim();
  const role = String(input.role || '').trim();
  if (!name || !role || name.length > 200 || role.length > 200) throw new Error('Enter a name and role, up to 200 characters each.');
  let url;
  try { url = new URL(String(input.url || '').trim()); } catch { throw new Error('Enter a full http:// or https:// link.'); }
  if (!['http:', 'https:'].includes(url.protocol) || !url.hostname || url.username || url.password || url.href.length > 2048) throw new Error('Enter a full http:// or https:// link without login details.');
  return {name, role, url:url.href};
}
const check = result => {
  if (result.error) throw new Error('Could not save your applications. Please try again.');
  return result.data;
};
const jobApplications = {
  async canAccess() {
    const {data,error} = await supabase.rpc('can_use_job_applications');
    return !error && data === true;
  },
  async list() {
    const {data,error} = await supabase.from('job_applications').select('*').order('sort_order').order('created_at', {ascending:false});
    if (error) throw new Error('Could not load your applications. Please try again.');
    return data || [];
  },
  async save(input, id) {
    const fields = validateApplication(input);
    const query = id ? supabase.from('job_applications').update(fields).eq('id',id) : supabase.from('job_applications').insert(fields);
    return check(await query.select().single());
  },
  async complete(id, completed) {
    return check(await supabase.from('job_applications').update({is_completed:completed}).eq('id',id).select().single());
  },
  async remove(id) {
    const data = check(await supabase.from('job_applications').delete().eq('id',id).select('id').single());
    return data;
  },
  async reorder(ids) { check(await supabase.rpc('reorder_job_applications', {p_ids:ids})); },
};
export default jobApplications;
